import { useState } from 'react';
import {
  AusschreibungBoard,
  AusschreibungTicker,
} from '../../components/stellenausschreibungen';
import { AusschreibungScope } from '../../types/stellenausschreibung';

const TABS: { scope: AusschreibungScope; label: string; hint: string }[] = [
  {
    scope: AusschreibungScope.BEDARF,
    label: 'Bedarfe',
    hint: 'Eine Anzeige je Stelle — mit Schule und Stundenumfang.',
  },
  {
    scope: AusschreibungScope.ORT,
    label: 'Orte',
    hint: 'Eine allgemeine Anzeige je Ort, in dem Bedarfe offen sind.',
  },
];

export function StellenausschreibungenPage() {
  const [scope, setScope] = useState<AusschreibungScope>(AusschreibungScope.BEDARF);
  const aktiverTab = TABS.find((t) => t.scope === scope)!;

  return (
    // Ab xl füllt die Seite den Viewport (100vh minus das p-6 des Layouts) und
    // verteilt die Höhe per Flex — darunter stapelt sich alles und darf wachsen.
    <div className="flex flex-col gap-4 xl:h-[calc(100vh-3rem)]">
      <div className="flex flex-wrap items-center justify-between gap-3 shrink-0">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            Stellenausschreibungen
          </h1>
          <p className="text-sm text-gray-500 mt-0.5">{aktiverTab.hint}</p>
        </div>

        <div
          className="inline-flex rounded-md shadow-sm"
          role="group"
          aria-label="Ansicht"
        >
          {TABS.map((tab, i) => (
            <button
              key={tab.scope}
              type="button"
              onClick={() => setScope(tab.scope)}
              aria-pressed={scope === tab.scope}
              className={`px-4 py-2 text-sm font-medium border border-gray-300 ${
                i === 0 ? 'rounded-l-md' : '-ml-px rounded-r-md'
              } ${
                scope === tab.scope
                  ? 'bg-primary-600 text-white border-primary-600 z-10'
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Der Ticker bekommt eine feste Breite, das Board den Rest: fünf Spalten
          neben der Sidebar sind knapp, und ein Grid-Bruchteil würde die letzte
          Spalte anschneiden, statt das Board sauber scrollen zu lassen. */}
      <div className="flex flex-col-reverse xl:flex-row gap-4 xl:flex-1 xl:min-h-0">
        <div className="flex-1 min-w-0 w-full xl:min-h-0">
          <AusschreibungBoard scope={scope} />
        </div>
        {/* 50% breiter, sobald das Fenster es hergibt. Vier lesbare Spalten
            (4x240 + eingeklappte 40 + Abstände = 1048px) und ein 432px-Ticker
            brauchen zusammen ~1800px; darunter bliebe sonst ausgerechnet
            „Zu deaktivieren" außerhalb des Bildes. */}
        <div className="w-full xl:w-72 min-[1800px]:w-[27rem] xl:shrink-0 xl:min-h-0">
          <AusschreibungTicker />
        </div>
      </div>
    </div>
  );
}
